import { render, staticRenderFns } from "./cambio-jefe-hogar-resumen.vue?vue&type=template&id=b3449adc&"
import script from "./cambio-jefe-hogar-resumen.vue?vue&type=script&lang=ts&"
export * from "./cambio-jefe-hogar-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports